/* 操作人员的变动 - status
    1-加 0-减 2-替换 -1-恢复
*/

/* 操作模式 - flowType
    1-全自动 || 0-半自动
*/

/* 操作类型 - BQ_TYPES （全自动）
export const BQ_TYPES = [
    { label: '批增', value: 100, status: 1, tips: '请批量新增被保人' },
    { label: '批减', value: 10, status: 0, tips: '请选择要从订单中减掉的被保人' },
    { label: '批换', value: 1, status: 2, tips: '用需要新投保的人员替换不再需要投保的人员' },
];
*/

// import { guideJson } from './initiate-preservation-static';
export const guideJson = [
    [
        {
            title: '发起保全',
            desc: '选择要发起保全的订单'
        },
        {
            title: '信息录入',
            desc: '准备好要变更的人员信息 并进行录入'
        },
        {
            title: '资料上传',
            slot: 'information'
        },
        {
            title: '保全初审',
            desc: '平均处理时间：1个工作日'
        },
        {
            title: '保全终审',
            slot: 'fianlAuditTime'
        },
        {
            title: '保全完成',
            desc: '保全完成，批单自动发送至邮箱'
        },
    ],
    [
        {
            title: '发起保全',
            desc: '选择要发起保全的订单'
        },
        {
            title: '信息录入',
            desc: '准备好要变更的人员信息 并选择需要的保全类型(加人/减人/替换)进行录入'
        },
        {
            title: '资料上传',
            slot: 'information'
        },
        {
            title: '保全审核',
            slot: 'fianlAuditTime'
        },
        {
            title: '保全完成',
            desc: '保全完成，批单自动发送至邮箱'
        },
    ]
]

export const stepJson = [
    {
        title: '选择保全类型',
        value: 'chooseType'
    },
    {
        title: '填写保全信息',
        value: 'fillPreservation'
    },
    {
        title: '人员变更确认',
        value: 'personnelConfirm'
    },
    {
        title: '上传保全资料',
        value: 'uploadPreservation'
    },
    {
        title: '确认并提交保全',
        value: 'submitPreservation'
    },
]

export const BQ_TYPES = [
    { label: '批增', value: 100, status: 1, tips: '请批量新增被保人' },
    { label: '批减', value: 10, status: 0, tips: '请选择要从订单中减掉的被保人' },
    { label: '批换', value: 1, status: 2, tips: '用需要新投保的人员替换不再需要投保的人员' },
];

export const BQ_TYPES_Json = {
    '100': { class: 'plan-wraper-add' },
    '10':  { class: 'plan-wraper-reduce' },
    '1':  { class: 'plan-wraper-change' },
};

//设备缓存key
export const personnelCacheKey = 'PERSONNEL_';

export const insuredIdTypeJson = {
    1: "身份证",
    2: "护照",
    3: "驾驶证",
    4: "港澳通行证",
    5: "军官证",
    6: "户口薄",
    7: "组织机构代码",
    8: "出生证明",
    99: "其他"
};

export const flowStatusCodeFilter = function (code) {
    switch (code) {
        case 10:
            return '待上传'
        case 20:
            return '待付款'
        case 21:
            return '付款待确认（对公转账）'
        case 30:
            return '资料待初审'
        case 31:
            return '保全待终审'
        case 35:
            return '审核待确认'
        case 36:
            return '保全待查询'
        case 39:
            return '保全待回调'
        case 40:
            return '保全成功'
        case 50:
            return '保全关闭'
        case 51:
            return '支付失败'
        case 52:
            return '保全驳回'
        case 53:
            return '已退保'
        // return '保全失败'
    }
}

export const replaceOrgKeys = [
    'orgInsuredName',
    'orgInsuredIdType',
    'orgInsuredIdNo',
    'orgInsuredSex',
    'orgBirthDay',
    'orgOccupationCode',
    'orgOccupationDesc',
    'orgOccupationType',
]



// WEBPACK FOOTER //
// ./src/util/preservation-static.js